import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Chip from '@mui/material/Chip'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import ToggleOffIcon from '@mui/icons-material/ToggleOff'
import ToggleOnIcon from '@mui/icons-material/ToggleOn'
import Typography from '@mui/material/Typography'

/**
 * One flag, whoever it reaches.
 *
 * The footer is the only part that differs between the two kinds of flag, so it arrives as a node:
 * the account a flag was granted to, or the note that it reaches everyone. The action beside it
 * differs for the same reason and arrives the same way.
 */
const FlagCard = props => (
  <Card className='flag' sx={{bgcolor: 'Background'}}>
    <CardContent sx={{display: 'flex', gap: '16px', justifyContent: 'space-between'}}>
      <Stack>
        <Stack className='name' direction='row'>
          {props.enabled ? <ToggleOnIcon color='primary' /> : <ToggleOffIcon color='disabled' />}
          <Typography variant='h6'>{props.name}</Typography>
        </Stack>
        {props.description && <Typography variant='body2'>{props.description}</Typography>}
      </Stack>
      <Chip
        size='small'
        sx={{flexShrink: 0}}
        label={props.status.label}
        color={props.status.color}
        variant={props.status.variant}
      />
    </CardContent>
    <Divider />
    <CardActions sx={{justifyContent: 'space-between'}}>
      {props.owner}
      {props.action}
    </CardActions>
  </Card>
)

export default FlagCard
